import { Button } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useParams, withRouter } from "react-router-dom";
import { Container, Header, Segment, Message } from "semantic-ui-react";

const ConfirmationResponseView: React.FC<any> = ({ history }) => {
  const { jobId } = useParams<{ jobId: string }>();
  const action = useParams<{ action: "confirm" | "decline" }>();
  const [response, setResponse] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [orderId, setOrderId] = useState<string | null>(null);

  useEffect(() => {
    // Extract response parameter from query string
    const urlParams = new URLSearchParams(window.location.search);
    const responseParam = action;
    const orderIdParam = urlParams.get('orderId');

    if (responseParam) {
      setResponse(responseParam.action);
      if (orderIdParam) {
        setOrderId(jobId);
      }
      // Process the response via API call
      processResponse(responseParam.action, jobId || "", orderIdParam || "");
    } else {
      setError("No response provided");
      setLoading(false);
    }
  }, [jobId]);

  const processResponse = async (responseType: string, id: string, orderId: string) => {
    try {
      setLoading(true);

      // Make API call to update order status
      const response = await fetch(`/api/confirm-order/${id}/${responseType}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ orderId })
      });

      // Could be an "Order already confirmed" or "Order already declined"
      if (response.status === 400) {
        throw new Error(await response.text());
      }

      // Could be an "Order not found"
      if (!response.ok) {
        throw new Error(await response.text());
      }

      const result = await response.json();
      console.log(`Processing response "${responseType}" for order ${id}:`, result);

    } catch (err) {
      // Throw actual error from API call
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    if (response === "confirm") {
      history.push("/orders");
    } else if (response === "decline") {
      history.push("/"); // Go to home page or show a decline message
    } else {
      history.push(`/modify-delivery/${jobId}`); // Navigate to modify page
    }
  };

  // Updated for proper response handling
  if (error) {
    return (
      <Container text style={{ paddingTop: "2em" }}>
        <Message error>
          <Message.Header>Error</Message.Header>
          <p>{error}</p>
          <Button
            onClick={() => history.push("/")}
            variant="outlined"
            color="inherit"
          >
            Home
          </Button>
        </Message>
      </Container>
    );
  }

  if (loading) {
    return (
      <Container text style={{ paddingTop: "2em" }}>
        <Segment>
          <Header as="h2">Processing your response...</Header>
          <p>Please wait while we process your confirmation.</p>
        </Segment>
      </Container>
    );
  }

  return (
    <Container text style={{ paddingTop: "2em" }}>
      <Segment raised>
        <Header as="h2">
          {response === "confirm" && "Job Confirmed!"}
          {response === "decline" && "Job Declined"}
        </Header>

        {response === "confirmed" && (
          <p>Your job has been confirmed successfully.</p>
        )}

        {response === "declined" && (
          <p>Your job has been declined. If this was a mistake, please contact us.</p>
        )}

        <Button
          color="primary"
          onClick={handleClick}
          style={{ marginTop: "1em" }}
        >
          {response === "confirm" && "View Your Orders"}
          {response === "decline" && "Go Home"}
        </Button>
      </Segment>
    </Container>
  );
};

export default withRouter(ConfirmationResponseView);

